// extracted by css-extract-rspack-plugin
export default {"contentWrapper":"AgentVerify_contentWrapper__tdUXL","resultBadgeWrapper":"AgentVerify_resultBadgeWrapper__AXuVL"};